import { queryClient } from '@shared/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { createRoleByCase } from 'services/ClaimscoreApiService/Permissions';
import type {
  CreateCaseRolePayload,
  CreateCaseRoleResponse,
} from 'services/ClaimscoreApiService/Permissions/types';

export const useCreateUserCaseRole = () =>
  useMutation<CreateCaseRoleResponse, Error, CreateCaseRolePayload>({
    mutationFn: ({ caseId, targetUsers }: CreateCaseRolePayload) =>
      createRoleByCase({
        caseId,
        targetUsers,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getCaseAccounts'] });
    },
  });
